// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__373LI","error":"Textarea_error__35vwi","readonly":"Textarea_readonly__TmKCo","disabled":"Textarea_disabled__349j7"};